import React, { useEffect } from 'react';
import { View, StyleSheet, Image } from 'react-native';
import * as Yup from 'yup';
import Screen from './../components/shared/Screen';
import { customToast, loadingToast, successToast } from './../utils/toasts';
import {
    ToplearnForm,
    ToplearnFormField,
    SubmitButton,
} from '../components/forms';
import { loginUser } from '../api/users';
import Toast from 'react-native-tiny-toast';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useDispatch } from "react-redux";
import { decodeToken } from "./../utils/token";
import { userAction,getHistories,getZirmajmoeh } from "./../actions/index";


const validationSchema = Yup.object().shape({
    meliCode: Yup.string()
        .required('این فیلد الزامی می باشد')
        .matches(/^([0-9]){10}$/g, 'کدملی می بایست ده رقم باشد'),
    password: Yup.string()
        .required('این فیلد الزامی می باشد')
        .min(4, 'کلمه عبور نباید کمتر از 4 کاراکتر باشد'),
});

const LoginScreen = ({ navigation, route }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (route.params.successRegister)
            successToast('ثبت نام موفقیت آمیز بود');
    }, []);

    const handleUserLogin = async (user) => {
        try {
            loadingToast('در حال برقراری ارتباط ...');
            const status = await loginUser(user);
            if (status === 200) {
                Toast.hide();
                successToast('ورود موفقیت آمیز بود');
                // navigation.navigate("Home");
                const token = await AsyncStorage.getItem('token');
                const userId = JSON.parse(await AsyncStorage.getItem('userId'));
                if (token !== null && userId !== null) {
                    const decodedToken = decodeToken(token);

                    dispatch(userAction(decodedToken.user));
                    dispatch(getHistories());
                    dispatch(getZirmajmoeh());
                }
                navigation.reset({
                    index: 0,
                    routes: [{ name: 'Home' }],
                });
            } else {
                Toast.hide();
                customToast('کدملی یا کلمه عبور صحیح نمی باشد');
            }
        } catch (err) {
            Toast.hide();
            console.log(err);
        }
    };

    return (
        <Screen style={styles.container}>
            <Image style={styles.logo} source={require('../assets/logo.png')} />
            <ToplearnForm
                initialValues={{ meliCode: '', password: '' }}
                // onSubmit={() => navigation.navigate("Home")}
                onSubmit={(user) => {
                    handleUserLogin(user);
                }}
                validationSchema={validationSchema}
            >
                <ToplearnFormField
                    placeholder="کد ملی"
                    autoCorrect={false}
                    icon="email"
                    name="meliCode"
                    placeholderTextColor="royalblue"
                />
                <ToplearnFormField
                    placeholder="کلمه عبور"
                    autoCompleteType="password"
                    autoCorrect={false}
                    icon="onepassword"
                    name="password"
                    placeholderTextColor="royalblue"
                    secureTextEntry
                />
                <View style={{ width: '60%' }}>
                    <SubmitButton title="ورود کاربر" />
                </View>
            </ToplearnForm>
        </Screen>
    );
};

export default LoginScreen;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    logo: {
        width: 190,
        height: 190,
        marginTop: 20,
        marginBottom: 40,
    },
});
